// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import VueFire from 'vuefire'
import database from './components/webmaster/Database/database'

//Store
import Vuex from 'vuex'
Vue.use(Vuex)
Vue.use(VueFire)
import store from './components/webmaster/Store/vuex'
import { firebaseConfig } from './components/webmaster/config/firebase'
//Alerts
import VueSweetAlert from 'vue-sweetalert'
Vue.use(VueSweetAlert)

require('../node_modules/pace-progress/pace.min.js')

//Global CSS
require('./assets/fonts/Montserrat-300,400,500,600,700.css')
require('../node_modules/bootstrap/dist/css/bootstrap.min.css')
require('../node_modules/ionicons/dist/css/ionicons.min.css')
require('../node_modules/font-awesome/css/font-awesome.min.css')
require('../node_modules/fullcalendar/dist/fullcalendar.min.css')
require('../node_modules/morris.js/morris.css')
require('./assets/vendor/md-snackbars/md-snackbars.min.css')
require('./assets/vendor/zabuto/zabuto_calendar.min.css')
require('./assets/vendor/datatables/datatables.min.css')
require('./assets/css/spark.css')
require('./assets/css/bootstrap-float-label.min.css')
//require('./assets/css/paceprogresscorner.css')

//Global JS
global.jQuery = require('../node_modules/jquery/dist/jquery.min.js')
global.Tether = require('../node_modules/tether/dist/js/tether.min.js')
//global.jsreports = require('./assets/js/jsreports-all.min.js')   

require('../node_modules/bootstrap/dist/js/bootstrap.min.js')
require('../node_modules/flot/jquery.flot.js')
//require('../node_modules/flot/jquery.flot.resize.js')
require('../node_modules/flot/jquery.flot.crosshair.js')
require('../node_modules/flot/jquery.flot.stack.js')
require('../node_modules/flot/jquery.flot.pie.js')
require('../node_modules/bxslider/dist/jquery.bxslider.min.js')
// jvectormap removed (unlicensed, and its world map was never rendered anywhere in the app).
require('../node_modules/moment/min/moment.min.js')
require('../node_modules/twitter-bootstrap-wizard/jquery.bootstrap.wizard.min.js')
//require('../node_modules/summernote/dist/summernote.min.js')
require('../node_modules/fullcalendar/dist/fullcalendar.min.js')
require('../node_modules/morris.js/morris.min.js')
require('../node_modules/raphael/raphael.min.js')
require('./assets/vendor/flot/jquery.flot.tooltip.min.js')
require('./assets/vendor/mark/jquery.mark.min.js')
require('./assets/vendor/md-snackbars/md-snackbars.min.js')
//require('./assets/vendor/zabuto/zabuto_calendar.min.js')
require('../node_modules/gmaps/gmaps.min.js')
require('./assets/js/spark.js')
require('./assets/js/pages/dashboard.js')

Vue.config.productionTip = false

//Global Variables
//Moment
import moment from 'moment'
Vue.prototype.moment = moment

//Firebase
const initApp = () => {
  if(firebase.apps.length == 0){
    firebase.initializeApp(firebaseConfig)
    database.init()
  }
}

initApp()

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js